import Vue from 'vue';
import Vuex from 'vuex';
import $ from 'jquery';
import 'jquery.cookie';
import Api from '../script/api';

Vue.use( Vuex );

export default new Vuex.Store( {
	state: {
		menu: [
			{ name: 'Reliability Test', url: '/test/', routeName: "Test" },
			{ name: 'Online Lecture', url: '/lecture/', routeName: "Lectures" }
		],
		navLeftSwitch: 'show',
		navTopSwitch: '',
		token: '',
		userData: {},
		views: 0,
		board: []
	},
	actions: {
		async handleSetUserData ( { commit }, payload ) {
			const res = await Api.get( "api/data_info", { Authorization: `Bearer ${ payload }` } );
			if ( res.res && res.msg === "ok" ) {
				const { survay, class_rating, qa } = res;
				const userData = JSON.stringify( {
					survay,
					class_rating,
					qa,
				} );
				localStorage.setItem( "userData", userData );
				commit( 'setUserData', { survay, class_rating, qa } );
			}
			return res;
		},
		handleSetToken ( { commit }, payload ) {
			$.cookie( "SMA", payload );
			commit( 'setToken', payload );
		},
		handleSetRemain ( { commit }, payload ) {
			commit( "setRemain", payload );
		},
		handleSetBoard ( { commit }, payload ) {
			commit( "setBoard", payload );
		}
	},
	mutations: {
		setUserData ( state, val ) {
			state.userData = val;
		},
		setToken ( state, val ) {
			state.token = val;
		},
		setRemain ( state, val ) {
			state.views = val;
		},
		setBoard ( state, val ) {
			state.board = val;
		},
		navLeftSwitch ( state, val ) { state.navLeftSwitch = val; },
		navTopSwitch ( state, val ) { state.navTopSwitch = val; },

	},
	getters: {
		getUserData ( state ) {
			if ( localStorage.getItem( "userData" ) !== "undefined" ) {
				state.userData = JSON.parse( localStorage.getItem( "userData" ) );
			}
			return state.userData;
		},
		getToken ( state ) {
			state.token = $.cookie( "SMA" );
			return state.token;
		},
		getRemain ( state ) {
			return state.views;
		},
		getBoardData ( state ) {
			return state.board;
		},
		navLeftSwitch ( state ) { return state.navLeftSwitch; },
		navTopSwitch ( state ) { return state.navTopSwitch; },

		menu ( state ) { return state.menu; },
	},

	modules: {
	}
} );
